import { classNames, convertToCurrencyFormat } from "../../../shared/utility";

interface Item {
  id: number;
  name: string;
  image1: string;
  total_sold: string;
}

interface ProductInventoryStatsProps {
  topSellingItemsStats: Item[];
  loading: Boolean;
}

const TopSellingItemsCard: React.FC<ProductInventoryStatsProps> = ({
  topSellingItemsStats,
  loading,
}) => {
  return (
    <li className="overflow-hidden h-max rounded-xl border border-gray-200 shadow-md">
      <div className="flex infos-center gap-x-4 border-b border-gray-900/5 bg-gray-50 px-6 py-4">
        <div className="text-xl font-medium leading-6 text-gray-900">
          Top Selling Items
        </div>
      </div>

      <div className="bg-white px-6 py-2 grid grid-cols-3 gap-4">
        {topSellingItemsStats.map((item, index) => (
          <div
            className={classNames(
              index > 0 ? "border-l border-gray-200" : null,
              "text-center space-y-4"
            )}
            key={item.id}
          >
            <img
              src={item.image1}
              alt={item.image1}
              title={item.image1}
              className="media-image rounded-md my-auto mx-auto w-30 h-30"
            />
            <p className="text-lg">{item.name}</p>
            <p className="text-xl font-bold">
              {convertToCurrencyFormat(item.total_sold)}
            </p>
          </div>
        ))}
      </div>
    </li>
  );
};

export default TopSellingItemsCard;
